import {createSlice} from '@reduxjs/toolkit';
import {createSelector} from 'reselect';

export const similarResourceSearchSlice = createSlice({
  name: 'similarResourceSearch',
  initialState: {
    isSimilarResourceSearch: false,
    resourceId: '',
    searchedType: {}
  },
  reducers: {
    setIsSimilarResourceSearch: (state, action) => {
      state.isSimilarResourceSearch = action.payload;
    },
    setResourceId: (state, action) => {
      state.resourceId = action.payload;
    },
    setSearchedType: (state, action) => {
      state.searchedType = action.payload;
    }
  }
});

export const {setIsSimilarResourceSearch, setResourceId, setSearchedType} = similarResourceSearchSlice.actions;

const similarResourceSearchSelector = (state) => state.similarResourceSearch;

export const isSimilarResourceSearchSelector = createSelector(
  [similarResourceSearchSelector],
  (similarResourceSearch) => similarResourceSearch.isSimilarResourceSearch
);
export const resourceIdSelector = createSelector(
  [similarResourceSearchSelector],
  (similarResourceSearch) => similarResourceSearch.resourceId
);
export const searchedTypeSelector = createSelector(
  [similarResourceSearchSelector],
  (similarResourceSearch) => similarResourceSearch.searchedType
);

export default similarResourceSearchSlice.reducer;
